// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 1024px) {
.home-title {
    width: 100%;
    font-weight: 800;
    font-size: 140px;
    line-height: 90%;
    }
   .about {
    margin-top: 50px;
    margin-bottom: 50px;
   }
   .about .faceless .title {
       font-weight: 800;
       font-size: 72px;
       line-height: 111%;
       width: 70%;
   }
   .about .about-msg {
       width: 232px;
        font-weight: 500;
        font-size: 20px;
        line-height: 132%;
   }
   .about .faceless {
    margin-bottom: 50px;
   }

   .about .figures .col-4 {
           width:40%;
       }
   .about .recommendation {
        border-radius: 40px;
        width: 90%;
   }
   .about .hireworkers{
      padding:100px;
   }

   .about .hireworkers .title {
        font-weight: 800;
        font-size: 48px;
        line-height: 117%;
    }
    .about .hireworkers .desc {
        font-weight: 500;
        font-size: 20px;
        line-height: 132%;
    }
   .about .recommendation .title {
        font-weight: 800;
        font-size: 48px;
        line-height: 117%;
   }
   .about .recommendation {
      padding: 50px;
   }
   .about .recommendation .form {
    padding: 10px;
   }
   .about .recommendation .form .title{
        font-weight: 700;
        font-size: 32px;
        line-height: 125%;
        margin-right: 25px;
   }
    .form .flag-icon {
       width: 32px;
       height: 32px;
       margin-right: -15px;
       }
    .about .recommendation .form .inputs .btn-group input {
           padding-left: 55px;
           font-size: 1.5rem;
           margin: 20px 10px;
           width: 270px;
       }
    .about .recommendation .form button {
      margin: 20px 10px;
      width: 140px
    }
    .about .join {
        width: 90%;
    }
    .about .join .form  {
        border-radius: 40px;
    }

    .about .join .form input {
        font-size: 1.5rem;
    }
    .about .join .links button {
        padding: 0 21px;
        margin-right: 25px;
    }
    .about .join .links svg {
        width: 32px;
        height: 32px;
    }
    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {
        line-height: 132%;
    }
    .profile .profile-section .header {
        font-size: 48px;
    }
    .user-badge .user-name {
        font-size: 20px;
    }
    .user-badge .stars img {
        width: 24px;
    }
    .user-badge .stars img {
        width: 24px;
    }
    .recommender-batch .stars img {
        width: 32px;
    }
    .avatar-container {
        width: 192px;
        height: 192px;
        position: relative;
    }
    .avatar-container .ava-cam {
        left: 74px;
        top: 74px;
    }
    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {
         font-size: 20px;
     }
    .recommendation .rating-gauge .label, .recommendation .rating-gauge {
        font-size: 22px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/scss/media_width_1024.css"],"names":[],"mappings":"AAAA;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB;GACD;IACC,gBAAgB;IAChB,mBAAmB;GACpB;GACA;OACI,gBAAgB;OAChB,eAAe;OACf,iBAAiB;OACjB,UAAU;GACd;GACA;OACI,YAAY;QACX,gBAAgB;QAChB,eAAe;QACf,iBAAiB;GACtB;GACA;IACC,mBAAmB;GACpB;;GAEA;WACQ,SAAS;OACb;GACJ;QACK,mBAAmB;QACnB,UAAU;GACf;GACA;MACG,aAAa;GAChB;;GAEA;QACK,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;GACD;QACK,gBAAgB;QAChB,eAAe;QACf,iBAAiB;GACtB;GACA;MACG,aAAa;GAChB;GACA;IACC,aAAa;GACd;GACA;QACK,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;GACvB;IACC;OACG,WAAW;OACX,YAAY;OACZ,mBAAmB;OACnB;IACH;WACO,kBAAkB;WAClB,iBAAiB;WACjB,iBAAiB;WACjB,YAAY;OAChB;IACH;MACE,iBAAiB;MACjB;IACF;IACA;QACI,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,SAAS;IACb;IACA;SACK,eAAe;KACnB;IACD;QACI,eAAe;IACnB;AACJ","sourcesContent":["@media all and (min-width: 1024px) {\n.home-title {\n    width: 100%;\n    font-weight: 800;\n    font-size: 140px;\n    line-height: 90%;\n    }\n   .about {\n    margin-top: 50px;\n    margin-bottom: 50px;\n   }\n   .about .faceless .title {\n       font-weight: 800;\n       font-size: 72px;\n       line-height: 111%;\n       width: 70%;\n   }\n   .about .about-msg {\n       width: 232px;\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 132%;\n   }\n   .about .faceless {\n    margin-bottom: 50px;\n   }\n\n   .about .figures .col-4 {\n           width:40%;\n       }\n   .about .recommendation {\n        border-radius: 40px;\n        width: 90%;\n   }\n   .about .hireworkers{\n      padding:100px;\n   }\n\n   .about .hireworkers .title {\n        font-weight: 800;\n        font-size: 48px;\n        line-height: 117%;\n    }\n    .about .hireworkers .desc {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 132%;\n    }\n   .about .recommendation .title {\n        font-weight: 800;\n        font-size: 48px;\n        line-height: 117%;\n   }\n   .about .recommendation {\n      padding: 50px;\n   }\n   .about .recommendation .form {\n    padding: 10px;\n   }\n   .about .recommendation .form .title{\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 125%;\n        margin-right: 25px;\n   }\n    .form .flag-icon {\n       width: 32px;\n       height: 32px;\n       margin-right: -15px;\n       }\n    .about .recommendation .form .inputs .btn-group input {\n           padding-left: 55px;\n           font-size: 1.5rem;\n           margin: 20px 10px;\n           width: 270px;\n       }\n    .about .recommendation .form button {\n      margin: 20px 10px;\n      width: 140px\n    }\n    .about .join {\n        width: 90%;\n    }\n    .about .join .form  {\n        border-radius: 40px;\n    }\n\n    .about .join .form input {\n        font-size: 1.5rem;\n    }\n    .about .join .links button {\n        padding: 0 21px;\n        margin-right: 25px;\n    }\n    .about .join .links svg {\n        width: 32px;\n        height: 32px;\n    }\n    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {\n        line-height: 132%;\n    }\n    .profile .profile-section .header {\n        font-size: 48px;\n    }\n    .user-badge .user-name {\n        font-size: 20px;\n    }\n    .user-badge .stars img {\n        width: 24px;\n    }\n    .user-badge .stars img {\n        width: 24px;\n    }\n    .recommender-batch .stars img {\n        width: 32px;\n    }\n    .avatar-container {\n        width: 192px;\n        height: 192px;\n        position: relative;\n    }\n    .avatar-container .ava-cam {\n        left: 74px;\n        top: 74px;\n    }\n    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {\n         font-size: 20px;\n     }\n    .recommendation .rating-gauge .label, .recommendation .rating-gauge {\n        font-size: 22px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
